import { LegalLayout, LegalSection, COMPANY } from "../components/LegalLayout";
import { useLanguage } from "../contexts/LanguageContext";

export default function PrivacyPolicy() {
  const { language } = useLanguage();
  if (language === "en") {
    return (
      <LegalLayout title="Privacy Policy" testId="privacy-policy-page">
        <LegalSection title="Controller">
          <p>The {COMPANY.name} app is published by {COMPANY.name} (No. {COMPANY.siren}).</p>
        </LegalSection>
        <LegalSection title="Data">
          <p>We never sell, share or transfer any personal data to third parties. No data is used for advertising or
            commercial purposes.</p>
          <p>Only the information you enter yourself (email, profile, photos, messages) is used, solely to run the
            service, and is not kept beyond the lifetime of your account.</p>
        </LegalSection>
        <LegalSection title="Payments">
          <p>Payments are processed directly by Google Play or our secure payment provider. We never have access to your
            bank details.</p>
        </LegalSection>
        <LegalSection title="Account deletion">
          <p>You can delete your account and all your data at any time from Settings → Delete my account, or by writing
            to {COMPANY.email}.</p>
        </LegalSection>
      </LegalLayout>
    );
  }
  return (
    <LegalLayout title="Politique de confidentialité" testId="privacy-policy-page">
      <LegalSection title="Responsable">
        <p>L'application {COMPANY.name} est éditée par {COMPANY.name} (N° {COMPANY.siren}).</p>
      </LegalSection>
      <LegalSection title="Données">
        <p>Nous ne vendons, ne partageons et ne transmettons aucune donnée personnelle à des tiers. Aucune donnée n'est
          exploitée à des fins publicitaires ou commerciales.</p>
        <p>Seules les informations que vous saisissez vous-même (email, profil, photos, messages) sont utilisées, uniquement
          pour faire fonctionner le service, et ne sont pas conservées au-delà de la durée de vie de votre compte.</p>
      </LegalSection>
      <LegalSection title="Paiements">
        <p>Les paiements sont traités directement par Google Play ou notre prestataire de paiement sécurisé. Nous n'avons
          jamais accès à vos coordonnées bancaires.</p>
      </LegalSection>
      <LegalSection title="Suppression du compte">
        <p>Vous pouvez supprimer votre compte et toutes vos données à tout moment depuis Paramètres → Supprimer mon compte,
          ou en écrivant à {COMPANY.email}.</p>
      </LegalSection>
    </LegalLayout>
  );
}
